// extracted by mini-css-extract-plugin
export default {"pageWrap":"Yc-z","fullWidth":"Zc-z","heading":"_c-z","fullBleed":"ad-z","hidden":"bd-z"};